import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchBlogs = createAsyncThunk("blog/all-blogs", async () => {
  const response = await fetch(
    "https://joyfulserver.ddns.net:443/api/Blog/all-blogs"
  );
  const result = await response.json(); // API-dən gələn ümumi nəticəni alırıq
  return result.data; // Yalnız `data` hissəsini qaytarırıq
});

export const getBlog = createAsyncThunk("blogs/blog", async (id) => {
  const response = await fetch(
    `https://joyfulserver.ddns.net:443/api/Blog/blog/${id}`,
    {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }
  );
  const result = await response.json();
  return result.data;
});

export const deleteBlog = createAsyncThunk(
  "blogs/deleteBlog",
  async (blogId) => {
    const response = await fetch(
      `https://joyfulserver.ddns.net:443/api/Blog/delete-blog/${blogId}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      }
    );
    return await response.json();
  }
);

export const addBlog = createAsyncThunk("blog/add-blog", async (newBlog) => {
  const response = await fetch(
    "https://joyfulserver.ddns.net:443/api/Blog/add-blog",
    {
      method: "POST",
      // ❌ headers içində "Content-Type" təyin etmə
      body: newBlog, // FormData birbaşa bura göndərilir
    }
  );

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`API Error: ${errorText}`);
  }

  return await response.json();
});

const blogSlice = createSlice({
  name: "blogs",
  initialState: {
    blogs: [],
    selectedBlog: null,
    status: "idle",
    error: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchBlogs.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchBlogs.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.blogs = action.payload;
      })
      .addCase(fetchBlogs.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(addBlog.fulfilled, (state, action) => {
        state.blogs.push(action.payload);
      })

      .addCase(getBlog.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getBlog.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.selectedBlog = action.payload;
      })
      .addCase(getBlog.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(deleteBlog.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteBlog.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.blogs = state.blogs.filter((pr) => pr.id !== action.payload);
      })
      .addCase(deleteBlog.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default blogSlice.reducer;
